var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"frag",rawName:"v-frag"}]},[_c('employee-donations-table')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }